/* eslint-disable import/prefer-default-export */

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Switch, Checkbox, TextField } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  selector: {
    width: '100%',
    marginTop: 15,
    marginBottom: 15,
  },
  gridRight: {
    marginLeft: 5,
  },
  checkboxContainer: {
    display: 'flex',
    padding: '15px 0',
    justifyContent: 'space-around',
  },
  mainTitle: {
    fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '3px',
    textDecoration: 'none',
    padding: '8px 24px',
    color: '#ff9800',
  },
  checkboxField: {
    width: '50%',
  },
  checkboxGroup: {
    height: '340px',
  },
  scoreContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: '2px solid #ff9800',
    borderRadius: '10px',
    color: 'gray',
  },
  score: {
    padding: '0px 5px',
  },
}));
export const OrangeSwitch = withStyles({
  switchBase: {
    color: 'gray',
    '&$checked': {
      color: '#ff9800',
    },
    '&$checked + $track': {
      backgroundColor: '#ff9800',
    },
  },
  checked: {},
  track: {},
})(Switch);

export const OrangeCheckbox = withStyles({
  root: {
    color: '#ff9800',
    '&$checked': {
      color: '#ff9800',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export const OrangeTextField = withStyles({
  root: {
    fontFamily: 'Nunito, Roboto, Helvetica, Arial, sans-serif',
    '& label.Mui-focused': {
      color: '#ff9800',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#ff9800',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ff9800',
      },
    },
  },
})(TextField);
